module.exports = __webpack_public_path__ + "img/user-edit.c6850bd3.svg";